// extracted by mini-css-extract-plugin
module.exports = {"DescriptionListItem":"DescriptionListItem_DescriptionListItem__19b6n","ListItem":"DescriptionListItem_ListItem__tG7GY","listItemTitle":"DescriptionListItem_listItemTitle__1MGqB"};